import React from "react";
import { Container, SectionTitle } from "components";

function WhyChooseVanar() {
  return (
    <section className="relative py-[35px] laptop:py-[70px]">
      <Container>
        <div className="relative px-4 py-10 md:py-14 laptop:pt-[80px] laptop:pb-[60px] laptop:px-[140px] rounded-3xl bg-lightGray/20 border-[1.5px] border-dim/10 overflow-hidden chooseVanar">
          <div className="absolute top-0 left-0 w-full h-full rounded-3xl overflow-hidden">
            <img
              src={process.env.REACT_APP_S3_IMAGES_URL + "chooseVanarBg.webp"}
              alt=""
              className="w-full h-full object-cover"
            />
          </div>

          <div className="relative z-10">
            <SectionTitle title="Why Choose Vanar Launchpool?" />

            <div className="mt-10 md:mt-[60px] grid laptop:grid-cols-2 gap-4">
              <div className="col-span-1">
                <div className="max-w-[300px] laptop:max-w-[450px] mx-auto w-full h-full flex items-center justify-center">
                  <img
                    src={process.env.REACT_APP_S3_IMAGES_URL + "v.webp"}
                    alt=""
                    className="max-w-full max-h-full"
                  />
                </div>
              </div>
              <div className="col-span-1">
                <ul className="space-y-6 md:space-y-10 laptop:space-y-[48px] laptop:pl-[5vw]">
                  <li>
                    <h3 className="flex gap-6 items-center text-xl lg:text-xxl font-bold leading-none md:leading-6 text-green mb-3">
                      <span className="flex items-center justify-center w-4 h-4 md:w-[18px] md:h-[18px] *:w-full *:h-full">
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect width="18" height="18" rx="3" fill="#03D9AF" />
                          <path
                            d="M4 10.3333L6.85714 13L14 5"
                            stroke="#0D100D"
                            strokeWidth="2"
                          />
                        </svg>
                      </span>
                      Early Access
                    </h3>
                    <p className="text-sm md:text-base leading-6 md:leading-[30px] text-dim">
                      Be among the first to access and support cutting-edge
                      blockchain projects at their inception.
                    </p>
                  </li>
                  <li>
                    <h3 className="flex gap-6 items-center text-xl lg:text-xxl font-bold leading-none md:leading-6 text-green mb-3">
                      <span className="flex items-center justify-center w-4 h-4 md:w-[18px] md:h-[18px] *:w-full *:h-full">
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M11.75 3L8 9H11.75L9.25 15L18 7.5H13L16.75 3H11.75Z"
                            fill="#B3F1D7"
                            fillOpacity="0.8"
                          />
                          <path
                            d="M5.625 0L0 9H5.625L1.875 18L15 6.75H7.5L13.125 0H5.625Z"
                            fill="#03D9AF"
                          />
                        </svg>
                      </span>
                      More Utility
                    </h3>
                    <p className="text-sm md:text-base leading-6 md:leading-[30px] text-dim">
                      Add value to holding tokens from other projects
                    </p>
                  </li>
                  <li>
                    <h3 className="flex gap-6 items-center text-xl lg:text-xxl font-bold leading-none md:leading-6 text-green mb-3">
                      <span className="flex items-center justify-center w-4 h-4 md:w-[18px] md:h-[18px] *:w-full *:h-full">
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M9 0L11.1246 6.87539H18L12.4377 11.1246L14.5623 18L9 13.7508L3.43769 18L5.5623 11.1246L0 6.87539H6.87539L9 0Z"
                            fill="#03D9AF"
                          />
                        </svg>
                      </span>
                      Diverse Rewards
                    </h3>
                    <p className="text-sm md:text-base leading-6 md:leading-[30px] text-dim">
                      Benefit from a variety of farming rewards tailored to
                      different staking preferences and risk appetites.
                    </p>
                  </li>
                  <li>
                    <h3 className="flex gap-6 items-center text-xl lg:text-xxl font-bold leading-none md:leading-6 text-green mb-3">
                      <span className="flex items-center justify-center w-4 h-4 md:w-[18px] md:h-[18px] *:w-full *:h-full">
                        <svg
                          width="22"
                          height="14"
                          viewBox="0 0 22 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2.58579 8.41421C2.96086 8.78929 3.46957 9 4 9C4.53043 9 5.03914 8.78929 5.41421 8.41421C5.78929 8.03914 6 7.53043 6 7C6 6.46957 5.78929 5.96086 5.41421 5.58579C5.03914 5.21071 4.53043 5 4 5C3.46957 5 2.96086 5.21071 2.58579 5.58579C2.21071 5.96086 2 6.46957 2 7C2 7.53043 2.21071 8.03914 2.58579 8.41421Z"
                            fill="url(#paint0_linear_18908_8560)"
                          />
                          <path
                            d="M6 13V12C6 10.6739 6.52678 9.40215 7.46447 8.46447C8.40215 7.52678 9.67392 7 11 7C12.3261 7 13.5979 7.52678 14.5355 8.46447C15.4732 9.40215 16 10.6739 16 12V13M11 7C11.7956 7 12.5587 6.68393 13.1213 6.12132C13.6839 5.55871 14 4.79565 14 4C14 3.20435 13.6839 2.44129 13.1213 1.87868C12.5587 1.31607 11.7956 1 11 1C10.2044 1 9.44129 1.31607 8.87868 1.87868C8.31607 2.44129 8 3.20435 8 4C8 4.79565 8.31607 5.55871 8.87868 6.12132C9.44129 6.68393 10.2044 7 11 7Z"
                            fill="url(#paint1_linear_18908_8560)"
                          />
                          <path
                            d="M1 13V12C1 11.2044 1.31607 10.4413 1.87868 9.87868C2.44129 9.31607 3.20435 9 4 9M4 9C3.46957 9 2.96086 8.78929 2.58579 8.41421C2.21071 8.03914 2 7.53043 2 7C2 6.46957 2.21071 5.96086 2.58579 5.58579C2.96086 5.21071 3.46957 5 4 5C4.53043 5 5.03914 5.21071 5.41421 5.58579C5.78929 5.96086 6 6.46957 6 7C6 7.53043 5.78929 8.03914 5.41421 8.41421C5.03914 8.78929 4.53043 9 4 9ZM6 13V12C6 10.6739 6.52678 9.40215 7.46447 8.46447C8.40215 7.52678 9.67392 7 11 7M11 7C12.3261 7 13.5979 7.52678 14.5355 8.46447C15.4732 9.40215 16 10.6739 16 12V13M11 7C11.7956 7 12.5587 6.68393 13.1213 6.12132C13.6839 5.55871 14 4.79565 14 4C14 3.20435 13.6839 2.44129 13.1213 1.87868C12.5587 1.31607 11.7956 1 11 1C10.2044 1 9.44129 1.31607 8.87868 1.87868C8.31607 2.44129 8 3.20435 8 4C8 4.79565 8.31607 5.55871 8.87868 6.12132C9.44129 6.68393 10.2044 7 11 7ZM21 13V12C21 11.2044 20.6839 10.4413 20.1213 9.87868C19.5587 9.31607 18.7956 9 18 9M18 9C18.5304 9 19.0391 8.78929 19.4142 8.41421C19.7893 8.03914 20 7.53043 20 7C20 6.46957 19.7893 5.96086 19.4142 5.58579C19.0391 5.21071 18.5304 5 18 5C17.4696 5 16.9609 5.21071 16.5858 5.58579C16.2107 5.96086 16 6.46957 16 7C16 7.53043 16.2107 8.03914 16.5858 8.41421C16.9609 8.78929 17.4696 9 18 9Z"
                            stroke="#03D9AF"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear_18908_8560"
                              x1="1"
                              y1="1"
                              x2="13.9778"
                              y2="17.8006"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop offset="0.268769" stopColor="#50FDDB" />
                              <stop offset="0.691445" stopColor="#03D9AF" />
                            </linearGradient>
                            <linearGradient
                              id="paint1_linear_18908_8560"
                              x1="1"
                              y1="1"
                              x2="13.9778"
                              y2="17.8006"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop offset="0.268769" stopColor="#50FDDB" />
                              <stop offset="0.691445" stopColor="#03D9AF" />
                            </linearGradient>
                          </defs>
                        </svg>
                      </span>
                      Community-Driven
                    </h3>
                    <p className="text-sm md:text-base leading-6 md:leading-[30px] text-dim">
                      Join a community of like-minded enthusiasts and investors
                      dedicated to driving innovation in the blockchain space.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}

export default WhyChooseVanar;
